var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import styles from './index.less';
export var UIUpload = function (props) {
    var style = props.style, className = props.className, _a = props.acceptTypes, acceptTypes = _a === void 0 ? ['gif', 'png', 'jpeg', 'jpg'] : _a, maxSize = props.maxSize, onChange = props.onChange, onError = props.onError, children = props.children;
    var View = useComponents().View;
    // 格式化类型
    var formateAcceptType = function () { return acceptTypes.map(function (type) { return "image/" + type; }).join(','); };
    // 上传
    var onChangeInput = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var file, imgValidate, formData;
        var _a;
        return __generator(this, function (_b) {
            file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
            imgValidate = validate(file);
            if (imgValidate.check) {
                formData = new FormData();
                formData.append('file', file);
                onChange(formData);
            }
            else {
                onError === null || onError === void 0 ? void 0 : onError(imgValidate.tip);
            }
            // 可以重复上传
            e.target.value = '';
            return [2 /*return*/];
        });
    }); };
    // 触发上传
    var onClickUpload = function () {
        var _a;
        (_a = document.getElementById('upload')) === null || _a === void 0 ? void 0 : _a.click();
    };
    // 校验
    var validate = function (file) {
        var check = true;
        var tip = '';
        if (!file) {
            check = false;
            tip = '上传失败';
        }
        else {
            if (maxSize && file.size > maxSize) {
                check = false;
                tip = '图片过大，上传失败';
            }
            else {
                // 校验类型
                var index = file.name.lastIndexOf('.');
                var ext = file.name.slice(index + 1).toLowerCase();
                if (!acceptTypes.includes(ext)) {
                    check = false;
                    tip = '类型不符，上传失败';
                }
            }
        }
        return {
            check: check,
            tip: tip,
        };
    };
    return (React.createElement(View, { className: styles['upload-container'] + " " + className, style: style },
        React.createElement("input", { id: "upload", type: "file", name: "file", accept: formateAcceptType(), onChange: onChangeInput }),
        React.createElement(View, { className: styles['upload-content'], onClick: onClickUpload }, children)));
};
